<template>
  <div>
    <h5 class="text-center text-warning mt-5">
      Error : Failed to fetch
      <span class="material-icons icons-aling">signal_wifi_statusbar_connected_no_internet_4</span>
    </h5>
    <p class="text-center text-info mt-3">Check your Internet connection</p>
    <div class="text-center mt-2 mb-5 mt-3">
      <a v-bind:href="redirect">
        <button class="btn btn-secondary box text-light text-center">Try Again</button>
      </a>
    </div>

  </div>
</template>
<script>
  export  default {
    name : 'Loading Fail',
    props: ['redirect'],
  }
</script>